/** Copy for the informational hero + status line. The test presents what was
 *  observed; it does not pass judgement on the user's setup. */
import type { Phase } from "./types";

export const IDLE_TINT = "rgba(43,232,43,0.05)";
export const INTRO = "Check which DNS you're using with our multi-resolver DNS test. We log nothing.";

export function ctaLabel(phase: Phase): string {
  return phase === "running" ? "Running — Press to Stop" : phase === "done" ? "Run Again" : "Run Leak Test";
}

export function statusLine(phase: Phase, lit: number, count: number, found: number, stopped = false): string {
  if (phase === "running") return `lookup ${lit} of ${count} · ${found} resolver${found === 1 ? "" : "s"} answered`;
  if (phase === "done") return `test ${stopped ? "stopped" : "complete"} · ${found} resolver${found === 1 ? "" : "s"} answered`;
  return " ";
}
